export default __webpack_public_path__ + "static/media/cape2Cairo.f3e01878.jpg";